import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import TextBooks from "../components/payments/TextBooks";

import { addThousandPoint,LoginAfterCheckLogin } from "../../components/common/Common";
import "../../css/style.css";

//교재 구매 신청
const TextBookOrder = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검\
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  let textbook_idx = 0;
  const  navigate = useNavigate();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const newBooks = {tb_idx:0,tb_bh_idx:branch_idx,tb_number:0,tb_amount:0};
  const newBookOrder = {tbl_idx:0,tb_idx:0,vb_idx:0,tbl_number:0,tbl_price:0};
  const [varBookOrders,setBookOrders] = useState([]);
  const [varBookInfo,setBookInfo] = useState({});
  const [varBookList,setBookList] = useState([]);

  const [varMode,setMode] = useState(0);

  //교재 정보 호출
  const GetBooksInformation = async() => {
    const sendData  = {branch_idx:branch_idx};
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_textbook_information`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //교재정보
        setBookList(datas.books);
        //교재주문정보
        const tb_idx = datas.tb_idx;
        newBooks.tb_idx = tb_idx;
        textbook_idx = tb_idx;
        //교재구입정보를 저장할 객체
        setBookInfo(newBooks);
        //주문교재별 정보저장
        newBookOrder.tb_idx = tb_idx;
        setBookOrders(varBookOrders.concat(newBookOrder));
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //교재내역호출
    GetBooksInformation();
    //저장하지 않고  종료하면 삭제
    return ()=>{ 
      DeleteNookOrder(textbook_idx); 
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //합계 재계산
  useEffect(() => {
    let totalNumber = 0;
    let totalPrice = 0;
    console.log(varBookOrders);
    for(var i=0; i<varBookOrders.length; i++) {
      totalNumber += varBookOrders[i].tbl_number;
      totalPrice += varBookOrders[i].tbl_price * varBookOrders[i].tbl_number;
      console.log(totalPrice);
    }
    setBookInfo({...varBookInfo,tb_number:totalNumber,tb_amount:totalPrice})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varBookOrders]);

  //교재신청
  const onOrderTextBookHandler = async(e) => {
    const imax = varBookOrders.length;
    const lastData = varBookOrders[imax-1];
    let lastList = [...varBookOrders];
    console.log(lastList);
    if(lastData.tbl_idx === 0 && (lastData.vb_idx === 0 || lastData.tbl_number === 0 || lastData.tbl_price === 0)) {
      lastList = lastList.filter(el=>el.tbl_idx > 0);
    }
    const sendData = {dataInfo:varBookInfo,dataList:lastList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_textbook`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        /* const tb_idx = datas.tb_idx;
        OrderTextBookDetail(tb_idx); */
        navigate(`/Branch/TextBookDetail/${varBookInfo.tb_idx}`);
      } else {
        alert(datas.message);
      }
    });
  }

  //교재 추가/삭제
  const onMangementBookHandler = async(e,tbl_idx) => {
    const OrderData = varBookOrders.find(el=>el.tbl_idx === tbl_idx);
    const findIndex = varBookOrders.findIndex(el=>el.tbl_idx === tbl_idx);
    console.log(varBookOrders,tbl_idx);
    if(tbl_idx === 0) { //추가
      const sendData = {dataInfo:OrderData};
      console.log(findIndex,sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_insert_textbook_list`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const tbl_idx = datas.tbl_idx;
          //교재객체에 주문고유번호 부여
          const copyList = [...varBookOrders];
          copyList[findIndex].tbl_idx = tbl_idx;
          //교재추가
          newBookOrder.tb_idx = OrderData.tb_idx;
          newBookOrder.tbl_idx = 0;
          newBookOrder.tbl_number = 0;
          setBookOrders(copyList.concat(newBookOrder));
        } else {
          alert(datas.message);
        }
      });
    } else {  //삭제
      const sendData = {tbl_idx:OrderData.tbl_idx};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_textbook_list`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          //교재객체에서 삭제
          const copyList = varBookOrders.filter(el=>el.tbl_idx !== tbl_idx);
          //빈배열이면 교재추가
          if(copyList.length === 0) {
            newBookOrder.tb_idx = OrderData.tb_idx;
            newBookOrder.tbl_idx = 0;
            newBookOrder.tbl_number = 0;
            copyList.push(newBookOrder);
          }
          setBookOrders(copyList);
        } else {
          alert(datas.message);
        }
      }); 
    }
  }

  //종료시 주문 취소
  const DeleteNookOrder = async(tb_idx) => {
    const sendData = {tb_idx:tb_idx};
    console.log(sendData);
    const result = await axios.post(`${process.env.REACT_APP_HOST}/branch_delete_textbook_all`,sendData);
    console.log(result);
  }

  //뒤로가기
  const onBackPageHandler = (e) => {
    navigate("/Branch/SettlementSet");
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'교재 구매 신청'}/>
      <div className="vh-content-body">
        <div className="textbook-wrap">
          <div className="center-wrap">
            <div className="tb-con">
              <div className="b-tit">
								<p>과목 선택</p>
								<p>단계 선택</p>
								<p>수량</p>
							</div>
            {varBookOrders.map((books,i)=>(
              <TextBooks key={'books_'+i} varIndex={books.tbl_idx} varMode={varMode} setMode={setMode} 
                    varBookList={varBookList} varBookOrders={varBookOrders} 
                    setBookOrders={setBookOrders} onMangementBookHandler={onMangementBookHandler}/>
            ))}
            </div>
            <div className="result-wrap">
							<div className="line">
								<p>총 수량</p>
								<div><b>{varBookInfo.tb_number}</b> 권</div>
							</div>
							<div className="line">
								<p>총 금액</p>
								<div><b>{addThousandPoint(varBookInfo.tb_amount)}</b> 원</div>
							</div>
						</div>
            <div className="form-contoller bt-btn">
							<button className="form-contoller-btn btn-no" style={{width:"48%"}} onClick={e=>onBackPageHandler(e)}>취소</button>
							<button type="button" className="form-contoller-btn btn-yes" onClick={e=>onOrderTextBookHandler(e)}>전송</button>
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default TextBookOrder;